import type { SVGProps } from 'react';

const SvgVersionsAddNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.53 14.15 17.09 12l1.43-.89a1.003 1.003 0 0 0-1.06-1.7L12 12.82 5.89 9 12 5.18l.67.42c.47.29 1.08.15 1.38-.32s.15-1.09-.32-1.38l-1.2-.75c-.32-.2-.74-.2-1.06 0l-8 5c-.29.18-.47.5-.47.85s.18.67.47.85L6.91 12l-3.44 2.15c-.29.18-.47.5-.47.85s.18.67.47.85l8 5a1.01 1.01 0 0 0 1.06 0l8-5c.29-.18.47-.5.47-.85s-.18-.67-.47-.85M12 18.82 5.89 15l2.91-1.82 2.67 1.67a1.01 1.01 0 0 0 1.06 0l2.67-1.67L18.11 15zM23 3h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgVersionsAddNew;
